import { isNumeric } from 'utils/helperMethods';
import { validators } from '../../utils/validators';
import { singleValueFields, multipleValuesFields } from './constants';

const validate = (values, props) => {
    const { REQUIRED, EMAIL, URL } = validators;
    const errors = {};

    singleValueFields.forEach(field => {
        if (field.required && REQUIRED(values[field.name])) {
            errors[field.name] = `Please enter ${field.label}`;
        }

        if (field.name === 'panNumber' && values.panNumber?.length !== 10) {
            errors.panNumber = 'Please enter 10 digit PAN Number';
        }

        if (field.name === 'aadharNumber' && values.aadharNumber?.length > 0 ) {
            
            if (values.aadharNumber?.length === 0 ) {
                // Check if the aadharNumber is empty
                errors.aadharNumber = 'Aadhar number is required';
            } 
            else if(values.aadharNumber?.length === 0 && values.aadharNumber?.includes('e')){

                errors.aadharNumber = 'Only Numeric Values are accepted';
            }
            else if (values.aadharNumber?.length !== 4 || !/^\d{4}$/.test(values.aadharNumber)) {
                // Check if the aadharNumber is not a 4-digit number
                errors.aadharNumber = 'Please enter only last 4 digits of Aadhar Number';
            }
        }

        if (
            field.name === 'pinCode' &&
            (values.pinCode?.length !== 6 || !isNumeric(values.pinCode))
        ) {
            errors.pinCode = 'Please enter 6 digit Pin Code';
        }
    });

    if (REQUIRED(values?.kycStatus)) {
        errors.kycStatus = 'Please Select KYC Status';
    }

    multipleValuesFields.forEach(field => {
        if (
            field.required &&
            !(values[field.name] && values[field.name].length > 0)
        ) {
            errors.commonErrors = `Please enter at-least one ${field.label}`;
            props.stopSubmit('mle-onboarding-form', errors);
        } else {
            const fieldErrorList = [];

            if (values[field.name]) {
                values[field.name].forEach((fieldValue, fieldValueIndex) => {
                    if (field.required && !(fieldValue && fieldValue.length)) {
                        fieldErrorList[
                            fieldValueIndex
                        ] = `Please enter  ${field.label}`;
                    }

                    if (field.name === 'emailIds' && EMAIL(fieldValue)) {
                        fieldErrorList[
                            fieldValueIndex
                        ] = `Please enter valid email Id`;
                    }

                    if (
                        field.name === 'mobileNumbers' &&
                        (fieldValue?.length !== 10 || !isNumeric(fieldValue))
                    ) {
                        fieldErrorList[
                            fieldValueIndex
                        ] = `Please enter valid 10 digit mobile number. Do not enter country code (+91)`;
                    }

                    if (field.name === 'uboPAN' && fieldValue?.length !== 10) {
                        fieldErrorList[
                            fieldValueIndex
                        ] = `Please enter valid 10 character PAN`;
                    }
                });
            }
            errors[field.name] = fieldErrorList;
        }
    });

    return errors;
};

export default validate;
